module.exports = __webpack_public_path__ + "static/media/product-2-back.7f905d00.jpg";